export const TOGGLE = 'MODAL/TOGGLE_MODAL_OPEN';
export const OPEN_CUSTOM = 'MODAL/OPEN_MODAL_WITH_CUSTOM_CONTENT';
export const OPEN_BASIC = 'MODAL/OPEN_MODAL_WITH_BASIC_CONTENT';
export const RENDER_TEMPLATE = 'MODAL/OPEN_MODAL_CONTAINING_LOADED_PAGE';
export const CLOSE = 'MODAL/CLOSE_MODAL';
export const ABOUT_PAGE_REQUEST = 'MODAL/MODAL_ABOUT_PAGE_REQUEST';
export const ABOUT_PAGE_REQUEST_START = 'MODAL/MODAL_ABOUT_PAGE_REQUEST_START';
export const ABOUT_PAGE_REQUEST_FAILURE = 'MODAL/MODAL_ABOUT_PAGE_REQUEST_FAILURE';
export const ABOUT_PAGE_REQUEST_SUCCESS = 'MODAL/MODAL_ABOUT_PAGE_REQUEST_SUCCESS';

export const ABOUT_MOCK_RESPONSE = '<html>MOCK</html>';
export const TEST_KEY = 'some-key-0000';
export const TEST_HEADER = 'TEST HEADER TEXT';
export const TEST_BODY = 'THIS IS TEST BODY TEXT';
